import DescriptionText from 'components/UI/V3/DescriptionText';
import { FunctionComponent } from 'react';
import styles from './EmailSenderSectionHeader.module.scss';

// Static description copy — describes the section as a whole, not the
// current state, so it's the same in every render and lives next to the
// component instead of being passed in. Copy declares the requirement
// upfront (a verified sender is mandatory to send campaigns) and skips any
// reference to the retired Cuddles-default fallback.
const DESCRIPTION =
    'A verified sender email is required to send marketing campaigns. Setup an email address so recipients see your domain in the From field.';

/**
 * Header shared by every Email Sender state. Mirrors the layout used by the
 * Email Campaigns and Email Templates tab headers — left-aligned title at
 * `font-size('lg')` + semibold, with a description below.
 *
 * Status badges are intentionally NOT rendered here — they belong next to the
 * entity they describe (the email itself), not next to the section title.
 * Each status state renders its own `email + badge` inline row in its body.
 */
const EmailSenderSectionHeader: FunctionComponent = () => {
    return (
        <>
            <h2 className={styles.title}>Email Sender</h2>
            <DescriptionText
                className={styles.description}
                text={DESCRIPTION}
            />
        </>
    );
};

export default EmailSenderSectionHeader;
